import { render } from "./mymusicxmlout.vue?vue&type=template&id=55b27c25"
import script from "./mymusicxmlout.vue?vue&type=script&lang=js"
export * from "./mymusicxmlout.vue?vue&type=script&lang=js"

import exportComponent from "F:\\TheDreamMusic\\aimusicxml\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__